interface IconEyeOpenProps {
	className?: string;
	size?: number;
	color?: string;
}

const IconEyeOpen: React.FC<IconEyeOpenProps> = ({
	className = "",
	size = 24,
	color = "currentColor",
}) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
			<path d="M20.9802 9.34267C18.8225 5.95213 15.6655 4 12.3403 4C10.6778 4 9.06188 4.4857 7.58611 5.39171C6.11033 6.30706 4.784 7.64273 3.70053 9.34267C2.76649 10.8091 2.76649 13.1909 3.70053 14.6573C5.85814 18.0572 9.01518 20 12.3403 20C14.0029 20 15.6188 19.5143 17.0946 18.6083C18.5703 17.6929 19.8967 16.3573 20.9802 14.6573C21.9142 13.2002 21.9142 10.8091 20.9802 9.34267ZM12.3403 15.7782C10.2481 15.7782 8.56684 14.0876 8.56684 12.0047C8.56684 9.92177 10.2481 8.23117 12.3403 8.23117C14.4326 8.23117 16.1138 9.92177 16.1138 12.0047C16.1138 14.0876 14.4326 15.7782 12.3403 15.7782Z" fill={color} />
			<path d="M12.3407 9.3333C10.8743 9.3333 9.67871 10.5289 9.67871 12.0046C9.67871 13.4711 10.8743 14.6666 12.3407 14.6666C13.8071 14.6666 15.012 13.4711 15.012 12.0046C15.012 10.5382 13.8071 9.3333 12.3407 9.3333Z" fill={color} />
		</svg>
	);
}

export default IconEyeOpen;
